import React, { useRef, useState } from "react";
import { api, errMsg, mediaUrl } from "@/lib/api";
import { toast } from "sonner";
import { Upload, X, Film } from "lucide-react";

export const Field = ({ label, value, onChange, textarea, type = "text", testId }) => (
  <div>
    <label className="block text-[0.62rem] uppercase tracking-[0.2em] text-neutral-500 mb-2">{label}</label>
    {textarea ? (
      <textarea data-testid={testId} rows={4} value={value || ""} onChange={(e) => onChange(e.target.value)}
        className="w-full bg-[#131313] border border-white/10 px-3 py-2.5 text-sm text-white outline-none focus:border-gold transition-colors duration-300" />
    ) : (
      <input data-testid={testId} type={type} value={value || ""} onChange={(e) => onChange(e.target.value)}
        className="w-full bg-[#131313] border border-white/10 px-3 py-2.5 text-sm text-white outline-none focus:border-gold transition-colors duration-300" />
    )}
  </div>
);

export const LocalizedField = ({ label, value, onChange, textarea = true, testId }) => (
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
    {["tr", "en", "de"].map((l) => (
      <Field key={l} label={`${label} (${l.toUpperCase()})`} textarea={textarea}
        testId={`${testId}-${l}`}
        value={(value || {})[l]} onChange={(v) => onChange({ ...(value || {}), [l]: v })} />
    ))}
  </div>
);

export const Uploader = ({ items, onChange, accept = "image/*,video/*", label = "Medya", testId }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    for (const f of files) {
      const fd = new FormData();
      fd.append("file", f);
      try {
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        onChange([...(items || []), { type: data.type, url: data.url }]);
      } catch (er) { toast.error(errMsg(er)); }
    }
    setBusy(false);
    if (ref.current) ref.current.value = "";
  };

  return (
    <div>
      <label className="block text-[0.62rem] uppercase tracking-[0.2em] text-neutral-500 mb-3">{label}</label>
      <div className="flex flex-wrap gap-3">
        {(items || []).map((m, i) => (
          <div key={i} className="relative w-24 h-24 border border-white/10 bg-black overflow-hidden group">
            {m.type === "video" ? (
              <div className="w-full h-full flex items-center justify-center"><Film size={20} className="text-gold" /></div>
            ) : (
              <img src={mediaUrl(m.url)} alt="" className="w-full h-full object-cover" />
            )}
            <button type="button" data-testid={`${testId}-remove-${i}`}
              onClick={() => onChange(items.filter((_, x) => x !== i))}
              className="absolute top-1 right-1 bg-black/80 p-1 text-white hover:text-red-400">
              <X size={12} />
            </button>
          </div>
        ))}
        <button type="button" data-testid={`${testId}-btn`} disabled={busy} onClick={() => ref.current?.click()}
          className="w-24 h-24 border border-dashed border-white/20 flex flex-col items-center justify-center gap-1 text-neutral-500 hover:border-gold hover:text-gold transition-colors duration-300 disabled:opacity-40">
          <Upload size={16} />
          <span className="text-[0.55rem] uppercase tracking-wider">{busy ? "..." : "Yükle"}</span>
        </button>
      </div>
      <input ref={ref} type="file" accept={accept} multiple hidden onChange={pick} data-testid={`${testId}-input`} />
    </div>
  );
};

export const SingleUpload = ({ value, onChange, accept, label, testId }) => {
  const items = value ? [{ type: accept?.includes("pdf") ? "pdf" : "image", url: value }] : [];
  return (
    <Uploader items={items} accept={accept} label={label} testId={testId}
      onChange={(arr) => onChange(arr.length ? arr[arr.length - 1].url : "")} />
  );
};
